module.exports = __webpack_public_path__ + "static/media/rufaida.6d8781b3.jpeg";